module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/philosophy01-fc040e63a1581ca920f069e51568f44c.png";